
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequest,
  FreelancersWorkforceCountryResource,
  FreelancersWorkforceMisclassificationThresholdResource,
} from '../models';
import {
    CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequestFromJSON,
    CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequestToJSON,
    FreelancersWorkforceCountryResourceFromJSON,
    FreelancersWorkforceCountryResourceToJSON,
    FreelancersWorkforceMisclassificationThresholdResourceFromJSON,
    FreelancersWorkforceMisclassificationThresholdResourceToJSON,
} from '../models';

export interface CreateFreelancersWorkforceMisclassificationThresholdRequest {
    organizationId: string;
    createOrUpdateFreelancersWorkforceMisclassificationThresholdRequest: CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequest;
}

export interface DeleteFreelancersWorkforceMisclassificationThresholdRequest {
    organizationId: string;
    misclassificationThresholdId: string;
}

export interface GetFreelancersWorkforceMisclassificationThresholdRequest {
    organizationId: string;
    misclassificationThresholdId: string;
}

export interface GetFreelancersWorkforceMisclassificationThresholdsWritePermissionsRequest {
    organizationId: string;
}

export interface ListFreelancersWorkforceCountriesRequest {
    organizationId: string;
}

export interface ListFreelancersWorkforceMisclassificationThresholdsRequest {
    organizationId: string;
}

export interface UpdateFreelancersWorkforceMisclassificationThresholdRequest {
    organizationId: string;
    misclassificationThresholdId: string;
    createOrUpdateFreelancersWorkforceMisclassificationThresholdRequest: CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequest;
}

/**
 * 
 */
export class FreelancersWorkforceMisclassificationThresholdsApi extends runtime.BaseAPI {

    /**
     * Create a freelancers workforce misclassification threshold
          */
    async createFreelancersWorkforceMisclassificationThresholdRaw(requestParameters: CreateFreelancersWorkforceMisclassificationThresholdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancersWorkforceMisclassificationThresholdResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling createFreelancersWorkforceMisclassificationThreshold().'
            );
        }

        if (requestParameters['createOrUpdateFreelancersWorkforceMisclassificationThresholdRequest'] == null) {
            throw new runtime.RequiredError(
                'createOrUpdateFreelancersWorkforceMisclassificationThresholdRequest',
                'Required parameter "createOrUpdateFreelancersWorkforceMisclassificationThresholdRequest" was null or undefined when calling createFreelancersWorkforceMisclassificationThreshold().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancersWorkforceMisclassificationThresholdResource>({
            path: `/compliance/api/freelancers/workforce/{organizationId}/misclassification-thresholds`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequestToJSON(requestParameters['createOrUpdateFreelancersWorkforceMisclassificationThresholdRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancersWorkforceMisclassificationThresholdResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Create a freelancers workforce misclassification threshold
          */
    async createFreelancersWorkforceMisclassificationThreshold(requestParameters: CreateFreelancersWorkforceMisclassificationThresholdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancersWorkforceMisclassificationThresholdResource> {
        const response = await this.createFreelancersWorkforceMisclassificationThresholdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Delete a freelancers workforce misclassification threshold by ID
          */
    async deleteFreelancersWorkforceMisclassificationThresholdRaw(requestParameters: DeleteFreelancersWorkforceMisclassificationThresholdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling deleteFreelancersWorkforceMisclassificationThreshold().'
            );
        }

        if (requestParameters['misclassificationThresholdId'] == null) {
            throw new runtime.RequiredError(
                'misclassificationThresholdId',
                'Required parameter "misclassificationThresholdId" was null or undefined when calling deleteFreelancersWorkforceMisclassificationThreshold().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/freelancers/workforce/{organizationId}/misclassification-thresholds/{misclassificationThresholdId}`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"misclassificationThresholdId"}}`, encodeURIComponent(String(requestParameters['misclassificationThresholdId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Delete a freelancers workforce misclassification threshold by ID
          */
    async deleteFreelancersWorkforceMisclassificationThreshold(requestParameters: DeleteFreelancersWorkforceMisclassificationThresholdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFreelancersWorkforceMisclassificationThresholdRaw(requestParameters, initOverrides);
    }

    /**
     * Get a freelancers workforce misclassification threshold by ID
          */
    async getFreelancersWorkforceMisclassificationThresholdRaw(requestParameters: GetFreelancersWorkforceMisclassificationThresholdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancersWorkforceMisclassificationThresholdResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getFreelancersWorkforceMisclassificationThreshold().'
            );
        }

        if (requestParameters['misclassificationThresholdId'] == null) {
            throw new runtime.RequiredError(
                'misclassificationThresholdId',
                'Required parameter "misclassificationThresholdId" was null or undefined when calling getFreelancersWorkforceMisclassificationThreshold().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancersWorkforceMisclassificationThresholdResource>({
            path: `/compliance/api/freelancers/workforce/{organizationId}/misclassification-thresholds/{misclassificationThresholdId}`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"misclassificationThresholdId"}}`, encodeURIComponent(String(requestParameters['misclassificationThresholdId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancersWorkforceMisclassificationThresholdResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get a freelancers workforce misclassification threshold by ID
          */
    async getFreelancersWorkforceMisclassificationThreshold(requestParameters: GetFreelancersWorkforceMisclassificationThresholdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancersWorkforceMisclassificationThresholdResource> {
        const response = await this.getFreelancersWorkforceMisclassificationThresholdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Check if the current user has write permissions on misclassification thresholds for the given organization
          */
    async getFreelancersWorkforceMisclassificationThresholdsWritePermissionsRaw(requestParameters: GetFreelancersWorkforceMisclassificationThresholdsWritePermissionsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<boolean>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getFreelancersWorkforceMisclassificationThresholdsWritePermissions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<boolean>({
            path: `/compliance/api/freelancers/workforce/{organizationId}/misclassification-thresholds/write-permissions`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Check if the current user has write permissions on misclassification thresholds for the given organization
          */
    async getFreelancersWorkforceMisclassificationThresholdsWritePermissions(requestParameters: GetFreelancersWorkforceMisclassificationThresholdsWritePermissionsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.getFreelancersWorkforceMisclassificationThresholdsWritePermissionsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * List countries available for the organization
          */
    async listFreelancersWorkforceCountriesRaw(requestParameters: ListFreelancersWorkforceCountriesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<FreelancersWorkforceCountryResource>>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling listFreelancersWorkforceCountries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<FreelancersWorkforceCountryResource>>({
            path: `/compliance/api/freelancers/workforce/{organizationId}/countries`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(FreelancersWorkforceCountryResourceFromJSON);
        return response;
    }

    /**
     * List countries available for the organization
          */
    async listFreelancersWorkforceCountries(requestParameters: ListFreelancersWorkforceCountriesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<FreelancersWorkforceCountryResource>> {
        const response = await this.listFreelancersWorkforceCountriesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * List freelancers workforce misclassification thresholds for the current organization
          */
    async listFreelancersWorkforceMisclassificationThresholdsRaw(requestParameters: ListFreelancersWorkforceMisclassificationThresholdsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<FreelancersWorkforceMisclassificationThresholdResource>>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling listFreelancersWorkforceMisclassificationThresholds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<FreelancersWorkforceMisclassificationThresholdResource>>({
            path: `/compliance/api/freelancers/workforce/{organizationId}/misclassification-thresholds`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(FreelancersWorkforceMisclassificationThresholdResourceFromJSON);
        return response;
    }

    /**
     * List freelancers workforce misclassification thresholds for the current organization
          */
    async listFreelancersWorkforceMisclassificationThresholds(requestParameters: ListFreelancersWorkforceMisclassificationThresholdsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<FreelancersWorkforceMisclassificationThresholdResource>> {
        const response = await this.listFreelancersWorkforceMisclassificationThresholdsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update a freelancers workforce misclassification threshold by ID
          */
    async updateFreelancersWorkforceMisclassificationThresholdRaw(requestParameters: UpdateFreelancersWorkforceMisclassificationThresholdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateFreelancersWorkforceMisclassificationThreshold().'
            );
        }

        if (requestParameters['misclassificationThresholdId'] == null) {
            throw new runtime.RequiredError(
                'misclassificationThresholdId',
                'Required parameter "misclassificationThresholdId" was null or undefined when calling updateFreelancersWorkforceMisclassificationThreshold().'
            );
        }

        if (requestParameters['createOrUpdateFreelancersWorkforceMisclassificationThresholdRequest'] == null) {
            throw new runtime.RequiredError(
                'createOrUpdateFreelancersWorkforceMisclassificationThresholdRequest',
                'Required parameter "createOrUpdateFreelancersWorkforceMisclassificationThresholdRequest" was null or undefined when calling updateFreelancersWorkforceMisclassificationThreshold().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/freelancers/workforce/{organizationId}/misclassification-thresholds/{misclassificationThresholdId}`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"misclassificationThresholdId"}}`, encodeURIComponent(String(requestParameters['misclassificationThresholdId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequestToJSON(requestParameters['createOrUpdateFreelancersWorkforceMisclassificationThresholdRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update a freelancers workforce misclassification threshold by ID
          */
    async updateFreelancersWorkforceMisclassificationThreshold(requestParameters: UpdateFreelancersWorkforceMisclassificationThresholdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateFreelancersWorkforceMisclassificationThresholdRaw(requestParameters, initOverrides);
    }

}
